/** Thrown when Storage cannot sign or return a patient-documents object. */
export class DocumentStorageAccessError extends Error {
  constructor() {
    super('document_storage_unavailable');
    this.name = 'DocumentStorageAccessError';
  }
}

export function isDocumentStorageAccessError(error: unknown): boolean {
  return (
    error instanceof DocumentStorageAccessError ||
    (error instanceof Error && error.message === 'document_storage_unavailable')
  );
}

/** i18n key for a download or preview failure. Storage misses get the specific sentence. */
export function documentAccessFailureKey(
  error: unknown,
): 'documents.file_unavailable' | 'documents.download_failed' {
  if (isDocumentStorageAccessError(error)) return 'documents.file_unavailable';
  return 'documents.download_failed';
}
